export default function checkJSONSyntax(string) {
    try {
        const obj = JSON.parse(string);
        return true;
    } catch (err) {
        return false;
    }
}